export default value => {
  if (!value) {
    return null
  }
  const date = new Date(value)
  return date.toLocaleString('et-ee', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
}
